import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Container, Row, Col, Form, Button, Spinner, Alert, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import { ticketTypeModification, getSingleTicketType } from "./TicketTypeAction";
import { useForm } from "react-hook-form";
import { useParams , useNavigate, Link} from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleRight, faRightToBracket, faUpload, faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons';
import Swal from 'sweetalert2';
import { getAllTicketType } from "./TicketTypeAction";
import { FaArrowLeft } from 'react-icons/fa';

const initialState = {
  id: "",
  ticket: "",
  status: "",

}



const ModifyTicketType = () => {
  let navigate = useNavigate();
    const {id}=useParams();

    const { stismloading, stmstatus, stmmessage  } = useSelector((state) => state.ticketTypesList);

    const dispatch = useDispatch();
    
    const [tickets, settickets] = useState({
      id:"",
      ticket:"",
      status:""
    });
    
 
    const [status, setStatus] = useState(0);
    const [modify, setModify] = useState(0);

    const ticketTypeData = useSelector((state) => state.ticketTypesList);

    useEffect(() => {
      dispatch(getAllTicketType());
     
  }, [dispatch,stmmessage]);



    const firstUpdate = useRef(true);
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      loadTicketType(id);
      return;
    }

  });
   useEffect(() => { 
    console.log('useEffect');
    loadTicketType(id);
    settickets({id:id,ticket:'',status:''});
   
     }, []);

     
     
 
    const { register, handleSubmit, formState: { errors } } = useForm();

   

    function loadTicketType(id){
    
      dispatch(getSingleTicketType(id));
      settickets({id:id,ticket:uData.reservation_ticket,status:uData.status});
   }

  
   const uData = JSON.parse(JSON.stringify(ticketTypeData.stSDetails));
   console.log(uData.ticket);

  const handleOnChange = e => {
    const name = e.target.name;
    const value = e.target.value;

    settickets({ ...tickets, [name]: value });
   
  };

  const handleOnSubmit = (e) => {
    e.preventDefault();
  
    const { id, ticket, status
    } = tickets;

    if (ticket === "" && status === "") {
      Swal.fire('No changes made!', '', 'info');
      navigate('/ticketypesList');
      return;
    }

    const ticketUpdation1 = {
      id,
      ticket,
      status
    };
   
    dispatch(ticketTypeModification(ticketUpdation1));
    setModify(1);
    navigate('/ticketypesList');
   
  
  };



  return (
    <>
             <div className="my-4  container-xl">
                <div className="card" style={{marginTop:'-80px'}}>
                    <div className="card-header">
                        <h3 className="d-flex text-dark text-left mt-2 mb-2"   style={{fontFamily:'Times New Roman' , fontWeight:'600'}}>Modify Ticket Type</h3>
                    </div>
                    <div className="card-body">
                        <Row>
                            <Link to="/ticketypesList"><span className="badge bg-success" style={{backgroundColor:'rgb(156 186 237)',color:'white'}}><FaArrowLeft />&nbsp;Go Back</span></Link> 
   
                        </Row>
                        <br />
            <Form className=" mx-4 my-2" component="form" noValidate   autoComplete="off" onSubmit={handleOnSubmit}>

              <Row className="mb-3">
                <Form.Group as={Col} controlId="formGridUsername">
                  <Form.Label>Ticket Type</Form.Label>
                  <Form.Control type="hidden" name="id" autoComplete='off' value={id} />
                 <Form.Control type="text"  name="ticket" value={tickets.ticket ? tickets.ticket : uData.ticket_type} autoComplete='off' placeholder="Enter Ticket Type" {...register("ticket", { required: true, minLength: 3 })} onChange={handleOnChange}/>
                </Form.Group>
               
              
                <Form.Group as={Col} controlId="formGridStatus">
                  <Form.Label>Status</Form.Label>
                  <Form.Select required name="status" value={tickets.status ? tickets.status : uData.status}  {...register("status")} onChange={handleOnChange}>
                    
                    <option value="">Choose..</option>
                    <option value="1">Enable</option>
                    <option value="0">Disable</option>
                  </Form.Select>
                  {errors.status && <p className='text-danger'>Status required</p>}
                </Form.Group>
              </Row>
              <div class="d-grid  col-2 mx-auto">
              <Button variant="primary" type="submit" className='align-middle'>
              <FontAwesomeIcon icon={faRightToBracket} /> Update
              </Button>
              </div>
            
            </Form>
            </div>
            
            </div>
            
            </div>
            
    </>
  );
}

export default ModifyTicketType;